export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-8815QFHD_white-ccb27bbbcaa3395307bab4496ab09c03.webp";